export const numberLayer = [
  { value: 2, text: '2' },
  { value: 4, text: '4' },
  { value: 6, text: '6' },
  { value: 8, text: '8' },
];

export const numberLayersQuickturn = [
  { value: 2, text: '2' },
  { value: 4, text: '4' },
  { value: 6, text: '6' },
];

export const silkscreenSide = [
  { value: 'Top Side', text: 'Top Side' },
  { value: 'Both Sides', text: 'Both Sides' },
  { value: 'Bottom Side', text: 'Bottom Side' },
  { value: 'None', text: 'None' },
];

export const silkscreenColor = [
  { value: 'White', text: 'White' },
  { value: 'Black', text: 'Black' },
  { value: 'Yellow', text: 'Yellow' },
];

export const stencilsThickness = [
  { value: '', text: 'Select One' },
  { value: 'Select For Me', text: 'Select For Me' },
  { value:'0.002', text: '0.002' },
  { value:'0.003', text: '0.003' },
  { value:'0.004', text: '0.004' },
  { value:'0.005', text: '0.005' },
  { value:'0.006', text: '0.006' },
  { value:'0.007', text: '0.007' },
  { value:'0.008', text: '0.008' },
  { value:'0.009', text: '0.009' },
  { value:'0.010', text: '0.010' },
  { value:'0.011', text: '0.011' },
  { value:'0.012', text: '0.012' },
  { value:'0.013', text: '0.013' },
  { value:'0.014', text: '0.014' },
  { value:'0.015', text: '0.015' },
];

export const stencilFiducialData = [
  { value: '', text: 'Select One' },
  { value: 'Delete fiducials/No fiducials', text: 'Delete fiducials/No fiducials' },
  { value: 'Etched Through', text: 'Etched Through' },
  { value: '1/2 Etched on Board Side', text: '1/2 Etched on Board Side' },
  { value: '1/2 Etched on Squeegee Side', text: '1/2 Etched on Squeegee Side' },
];

export const stencilLengthOptions = [
  { value: '', text: 'Select One' },
  { value: 'Select For Me', text: 'Select For Me' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
  { value: '4', text: '4' },
  { value: '5', text: '5' },
  { value: '6', text: '6' },
  { value: '7', text: '7' },
  { value: '8', text: '8' },
  { value: '9', text: '9' },
  { value: '10', text: '10' },
  { value: '11', text: '11' },
  { value: '12', text: '12' },
];

export const stencilsWidthOptions = [
  { value: '', text: 'Select One' },
  { value: 'Select For Me', text: 'Select For Me' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
  { value: '4', text: '4' },
  { value: '5', text: '5' },
  { value: '6', text: '6' },
  { value: '7', text: '7' },
  { value: '8', text: '8' },
  { value: '9', text: '9' },
  { value: '10', text: '10' },
];

export const materialTypeOptions = [
  {value: 'FR4TG170', text: 'FR4 Tg170'},
  {value: 'FR4', text: 'FR4 Tg135'}
];

export const materialTypeOptionsQuickturn = [
  {value: 'FR4TG180', text: 'FR4 Tg180'},
];


export const materialThicknessOptions = [
  { value: '0.125', text: '0.125"' },
  { value: '0.093', text: '0.093"' },
  { value: '0.062', text: '0.062"' },
  { value: '0.047', text: '0.047"' },
  { value: '0.040', text: '0.040"' },
  { value: '0.031', text: '0.031"' },
  { value: '0.020', text: '0.020"' },
  { value: '0.014', text: '0.014"' },
  { value: '0.010', text: '0.010"' },
];

export const finishPlatingOptions = [
  { value: 'Leaded Solder', text: 'Leaded Solder (HASL)' },
  { value: 'Lead Free Solder', text: 'Lead Free Solder (LF HASL)' },
  { value: 'Immersion Gold', text: 'Immersion Gold (ENIG)' },
  { value: 'OSP', text: 'OSP' },
  { value: 'Immersion Silver', text: 'Immersion Silver' },
];

export const finishPlatingOptionsQuickturn = [
  { value: 'Immersion Gold', text: 'Immersion Gold (ENIG)' },
];

export const copperOuterOptions = [
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];

export const copperInnerOptions = [
  { value: '0.5 oz', text: '0.5 oz' },
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];

export const soldermaskSideOptions = [
  { value: 'Top Side', text: 'Top Side' },
  { value: 'Both Sides', text: 'Both Sides' },
  { value: 'Bottom Side', text: 'Bottom Side' },
  { value: 'None', text: 'None' },
];

export const soldermaskColorOptions = [
  { value: 'Green', text: 'Green' },
  { value: 'Matte Green', text: 'Matte Green' },
  { value: 'Black', text: 'Black' },
  { value: 'Matte Black', text: 'Matte Black' },
  { value: 'Blue', text: 'Blue' },
  { value: 'Red', text: 'Red' },
  { value: 'White', text: 'White' },
];

export const blindBuriedHole = [
  { value: 'None', text: 'None' },
  { value: '2 drilling process', text: '2 drilling process' },
  { value: '3 drilling process', text: '3 drilling process' },
  { value: '4 drilling process', text: '4 drilling process' },
  { value: '5 drilling process', text: '5 drilling process' },
];

export const goldThicknessOptions = [
  { value: 'Au<10', text: 'Au < 10u"' },
  { value: '11<Au<20', text: '11u" < Au < 20u"' },
  { value: '21<Au<30', text: '21u" < Au < 30u"' },
  { value: '31<Au<39', text: '31u" < Au < 39u"' },
  { value: '40<Au<50', text: '40u" < Au < 50u"' },
  { value: '51<Au<120', text: '51u" < Au < 120u"' },
];

export const minTraceSpaceOptions = [
  { value: '0.012', text: '0.012' },
  { value: '0.01', text: '0.010' },
  { value: '0.008', text: '0.008' },
  { value: '0.007', text: '0.007' },
  { value: '0.006', text: '0.006' },
  { value: '0.005', text: '0.005' },
  { value: '0.004', text: '0.004' },
  { value: '0.0035', text: '0.0035' },
];

export const pitchOptions = [
  { value: '0.05', text: '0.050' },
  { value: '0.025', text: '0.025' },
  { value: '0.015', text: '0.015' },
  { value: '0.01', text: '0.010' },
  { value: '0.0', text: 'n/a' },
];

export const spacingTabRouted = [
  { value: '', text: 'Select One' },
  { value: '0.050', text: '0.050"' },
  { value: '0.062', text: '0.062"' },
  { value: '0.093', text: '0.093"' },
  { value: '0.200', text: '0.200"' },
];

export const spacingVScored = [
  { value: '', text: 'Select One' },
  { value: '0.000', text: '0.000"' },
  { value: '0.200', text: '0.200"' },
];

export const viaFill = [
  { value: 'none', text: 'None' },
  { value: 'resin', text: 'Resin (Non-Conductive)' },
  { value: 'copper', text: 'Copper (Conductive)' },
];
